export default __webpack_public_path__ + "static/media/plain-sticker-U.0976c523.png";